var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"toolbar",staticClass:"toolbar",staticStyle:{"position":"relative","z-index":"2"}}),_c('div',{ref:"editor",staticClass:"text",staticStyle:{"position":"relative","z-index":"1","height":"auto"}})])}
var staticRenderFns = []

export { render, staticRenderFns }